import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { AccountStorage } from "@services/account";
import accountMixin from "@mixin/account.js";
var accountStorage = new AccountStorage();
export default {
  components: {},
  data: function data() {
    return {
      loading: false,
      // confirmDisabled:true,
      isName: false,
      isGender: false,
      isPhone: false,
      popupStatus: false,
      //  弹窗
      isOriginal: false,
      originalErrorTxt: "",
      isAffirmPassword: false,
      genderList: [{
        id: 1,
        value: "男"
      }, {
        id: 2,
        value: "女"
      }],
      info: {
        name: "",
        gender: "",
        phone: ""
      },
      infoPassword: {
        original: "",
        // 原密码
        newPassword: "",
        // 新密码
        affirmPassword: "" // 确认新密码
      },
      userInfo: {},
      isExternal: false
      // bankCardInfo: {
      //   name: "",
      //   IDNumber: "",
      //   bankCardNUmber: "",
      //   bankName: ""
      // }
    };
  },
  computed: {
    confirmDisabled: function confirmDisabled() {
      var flag = this.infoPassword.original.length > 0 && this.infoPassword.newPassword.length > 0 && this.infoPassword.affirmPassword.length > 0 && this.infoPassword.newPassword === this.infoPassword.affirmPassword;
      return !flag;
    }
  },
  created: function created() {
    var userInfo = accountStorage.getCacheUserInfo();
    if (userInfo) {
      this.userInfo = userInfo;
      this.isExternal = userInfo.type == 1 ? true : false;
      if (userInfo.gender === "1") {
        this.userInfo.genderValue = "男";
      } else if (userInfo.gender === "2") {
        this.userInfo.genderValue = "女";
      }
    }
  },
  mixins: [accountMixin],
  methods: {
    oldPwdBlur: function oldPwdBlur() {
      this.isOriginal = false;
    },
    // 确认新密
    blurAffirmPassword: function blurAffirmPassword() {
      if (this.infoPassword.affirmPassword.length > 0) {
        if (this.infoPassword.newPassword !== this.infoPassword.affirmPassword) {
          this.isAffirmPassword = true;
        } else {
          this.isAffirmPassword = false;
        }
      } else {
        this.isAffirmPassword = false;
      }
    },
    blurAffirmInput: function blurAffirmInput() {
      this.isAffirmPassword = false;
    },
    // 清空原密码
    emptyOriginal: function emptyOriginal() {
      this.infoPassword.original = "";
    },
    // 新密码
    newPasswordBtn: function newPasswordBtn() {
      this.infoPassword.newPassword = "";
    },
    // 确认新密码
    affirmPasswordBtn: function affirmPasswordBtn() {
      this.infoPassword.affirmPassword = "";
    },
    //修改性别
    selecGenderChange: function selecGenderChange(val) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.isGender = false;
              if (val === "男") {
                _this.userInfo.gender = "1";
              } else {
                _this.userInfo.gender = "2";
              }
              params = {
                gender: _this.userInfo.gender
              };
              _context.next = 5;
              return _this.updateUserInfo(params);
            case 5:
              accountStorage.setCacheUserInfo(_this.userInfo);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //修改用户信息
    updateUserInfo: function updateUserInfo() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var params, _default, URL, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              _default = {
                id: _this2.userInfo.userId
              };
              _default = Object.assign(_default, params);
              URL = "/pjyy-deepexi-user-center/api/v1/customer/updateCustomerInfo";
              _context2.next = 6;
              return _this2.$getHttpClient().post(URL, _default);
            case 6:
              result = _context2.sent;
              if (!(result.data.code === "200")) {
                _context2.next = 9;
                break;
              }
              return _context2.abrupt("return", result.data.data);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handlename: function handlename() {
      this.isName = true;
    },
    handleGender: function handleGender() {
      this.isGender = true;
    },
    //修改用户名
    handleConfirm: function handleConfirm() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var params;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isName = false;
              params = {
                name: _this3.userInfo.userName
              };
              _context3.next = 4;
              return _this3.updateUserInfo(params);
            case 4:
              accountStorage.setCacheUserInfo(_this3.userInfo);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    //修改手机号
    handleConfirmPhone: function handleConfirmPhone() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var params;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.isPhone = false;
              // let reg = /^1[3456789]\d{9}$/;
              // let res = reg.test(this.userInfo.phone);
              // if (res) {
              params = {
                phone: _this4.userInfo.phone
              };
              _context4.next = 4;
              return _this4.updateUserInfo(params);
            case 4:
              accountStorage.setCacheUserInfo(_this4.userInfo);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    handlePhone: function handlePhone() {
      this.isPhone = true;
    },
    // 修改密码弹窗
    handleAmend: function handleAmend() {
      document.body.style.height = "".concat(document.documentElement.clientHeight, "px");
      document.body.style.overflow = "hidden";
      this.popupStatus = true;
      this.infoPassword.original = "";
      this.infoPassword.newPassword = "";
      this.infoPassword.affirmPassword = "";
    },
    handleCancel: function handleCancel() {
      document.body.style.height = "";
      document.body.style.overflow = "";
      this.popupStatus = false;
    },
    // 修改密码确定
    handleLodingConfirm: function handleLodingConfirm() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var URL, params, result;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.loading = true;
              URL = "/pjyy-deepexi-user-center/api/v1/common/updatePassword";
              params = {
                id: _this5.userInfo.userId,
                oldPassword: _this5.infoPassword.original,
                newPassword: _this5.infoPassword.newPassword,
                comfirmPwd: _this5.infoPassword.affirmPassword
              };
              _context5.next = 5;
              return _this5.$getHttpClient({
                useResponseToast: false
              }).post(URL, params);
            case 5:
              result = _context5.sent;
              _this5.loading = false;
              if (!(result.data.code !== "200")) {
                _context5.next = 12;
                break;
              }
              _this5.isOriginal = true;
              _this5.originalErrorTxt = result.data.msg;
              _context5.next = 17;
              break;
            case 12:
              document.body.style.height = "";
              document.body.style.overflow = "";
              _this5.popupStatus = false;
              _context5.next = 17;
              return _this5.pushLoginOut("updatePwd");
            case 17:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    }
  }
};